<template lang="html">
  <v-dialog v-model="showSessionModal" width="380" persistent>
    <login-form @success="onSuccessLogin"></login-form>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import LoginForm from './LoginForm';

export default {
  name: 'SessionModal',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState('applications', [
      'showSessionModal',
    ]),
  },
  methods: {
    onSuccessLogin() {
      this.$store.dispatch('applications/hideSessionModal');
      this.$store.dispatch('applications/setSuccessNotification', {
        message: 'Logged In successfully!',
      }).then(v => {

        this.$router.push({name: 'company.loads', params: { id: companyId }})
      });
    },
  },
};
</script>

<style lang="css" scoped>
  .google-login {
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/SessionModal.vue